import type { FunctionComponent, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";

import { INVOICE_DETAILS_PATH_WITH_ORIGIN } from "~/constants/appRoutes.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import {
	validInvoiceDetailsNavigatedFromOrigins,
} from "~/modules/billing/components/InvoiceDetailsView/invoiceDetailsUtils.ts";
import type { ProjectRevenueInvoice } from "~/modules/project/api/projectRevenueReport/projectRevenueReportTypes.ts";
import { getInvoiceAmountCents } from "~/modules/project/components/ProjectDetailsView/components/ProjectRevenueReportSection/projectRevenueReportUtils.ts";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";

type Props = {
	invoice: ProjectRevenueInvoice;
	invoiceDetails: Invoice | undefined;
};

const ProjectRevenueInvoiceEntry: FunctionComponent<Props> = ({ invoice, invoiceDetails }) => {
	const navigate = useNavigate();

	const invoiceNumber = invoiceDetails?.invoiceNumber ?? "Entwurf";
	const amountFormatted = formatCentsToCurrency(getInvoiceAmountCents(invoice));

	const handleClick = (event: MouseEvent) => {
		const path = INVOICE_DETAILS_PATH_WITH_ORIGIN(
			invoice.invoiceId,
			validInvoiceDetailsNavigatedFromOrigins.PROJECT_REVENUE_REPORT,
		);

		if (event.ctrlKey || event.metaKey) {
			window.open(path, "_blank");
		} else {
			navigate(path);
		}
	};

	return <button type="button"
				   onClick={handleClick}
				   className="flex w-full items-center justify-between gap-x-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm hover:bg-gray-50">
		<span className="font-medium text-gray-700">{invoiceNumber}</span>
		<span className="font-semibold text-gray-900">{amountFormatted}</span>
	</button>;
};

export default ProjectRevenueInvoiceEntry;
